module.exports = __webpack_public_path__ + "img/grooming8.0e68653f.jpg";